import { render, staticRenderFns } from "./BusinessWallMobilePreview.vue?vue&type=template&id=1956f502&scoped=true&"
import script from "./BusinessWallMobilePreview.vue?vue&type=script&lang=js&"
export * from "./BusinessWallMobilePreview.vue?vue&type=script&lang=js&"
import style0 from "./BusinessWallMobilePreview.vue?vue&type=style&index=0&id=1956f502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956f502",
  null
  
)

export default component.exports